import Avatar from '@mui/material/Avatar'
import Grid from '@mui/material/Grid2'
import { personAPI } from 'api/PersonAPI'
import CardContentText from 'Components/reusable/CaleoCustomComponents/CardContentText'
import React, { useEffect, useState } from 'react'
import { IPerson } from 'types/userInterfaces'

/** @notExported */
interface ISalesContactProps {
  /** Sales contact person */
  salesContact: IPerson
}

/**
 * Sales contact component.
 *
 * @returns Sales contact component.
 * @notExported
 */
const SalesContact: React.FC<ISalesContactProps> = ({ salesContact }) => {
  const [image, setImage] = useState<string>('')
  const contactName = `${salesContact.firstName} ${salesContact.lastName}`.trim()

  useEffect(() => {
    const controller = new AbortController()

    ;(async () => {
      const profileImage = await personAPI.getProfileImage(salesContact.id, controller)
      setImage(profileImage)
    })()

    return () => {
      controller.abort()
    }
  }, [salesContact.id])

  return (
    <Grid>
      <Grid container alignItems="center" direction="row" justifyContent="center" spacing={2}>
        <Grid>
          <Avatar src={image} sx={{ width: 80, height: 80 }} alt={contactName} />
        </Grid>
        <Grid>
          <Grid container alignItems="flex-start" direction="column" justifyContent="center">
            <Grid>
              <CardContentText type="header">{`${salesContact.firstName} ${salesContact.lastName}`}</CardContentText>
            </Grid>
            <Grid>
              <CardContentText>{salesContact.Account?.email}</CardContentText>
            </Grid>
            <Grid>
              <CardContentText>{salesContact.telephone}</CardContentText>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default SalesContact
